import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    // padding: "2rem",
    padding: "0 2rem",
    backgroundColor: "white",
  },
  upperBox: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: "white",
    paddingTop: "2rem",
  },
  upperBoxHeadText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#000000",
  },
  planNameContainer: {
    width: "100%",
    fontSize: "1.25rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    fontWeight: 600,
  },
  planNameText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  planNamePrice: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#272525",
  },
  planNameBtn: {
    border: "1px solid #4d1277",
    borderRadius: "8px",
    backgroundColor: "#4d1277",
    color: "white",
    paddingLeft: "12px",
    paddingRight: "12px",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "white",
      opacity: "0.8",
    },
    marginTop: "5px",
  },
  popularPlanText: {
    position: "absolute",
    top: "-1.1rem",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "10px",
    color: "#4D1277",
  },
  planNameBtnEnterprise: {
    border: "2px solid #4d1277",
    borderRadius: "8px",
    backgroundColor: "white",
    color: "#4d1277",
    paddingLeft: "12px",
    paddingRight: "12px",
    "&:hover": {
      backgroundColor: "white",
      color: "#4d1277",
      opacity: "0.8",
    },
    marginTop: "5px",
    //
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "0.875rem",
    lineHeight: "1.75",
    padding: "6px 8px",
    //
  },
  intervalText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    color: "#999999",
  },
  intervalTextChosen: {
    color: "#4D1277",
  },
  planHeaderContainer: {
    // paddingLeft: "2.25rem",
    // paddingRight: "2.25rem",
    padding: "1rem 2.25rem",
    display: "grid",
    // gridTemplateColumns: "52% 12% 12% 12% 12%",
    // gridTemplateColumns: "48% 14% 14% 14% 14%",
    gridTemplateColumns: "40% 15% 15% 15% 15%",
    alignItems: "center",
    borderColor: "#e2e2e4",
  },
  planFeatureRow: {
    display: "grid",
    // gridTemplateColumns: "52% 12% 12% 12% 12%",
    // gridTemplateColumns: "48% 14% 14% 14% 13%",
    gridTemplateColumns: "40% 15% 15% 15% 15%",
    alignItems: "center",
    padding: "10px 1.5rem",
    borderBottom: "1px solid #999999",
    paddingLeft: 0,
    marginBottom: "20px",
  },
  loaderBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "20vh",
  },
  loaderStyle: { color: "#4d1277", size: 15 },
  categoryText: {
    backgroundColor: "#EAE9E9",
    color: "#272525",
    padding: "13px",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
  },
  featureTextBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
  },
  featureText: {
    // fontSize: "14px",
    // lineHeight: "22px",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#000000",
  },
  tooltip: {
    color: "#8e8e90",
    cursor: "pointer",
    "&:hover": {
      color: "black",
    },
    transform: "rotate(180deg)",
  },
  selectedFeatureBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  checkIcon: {
    color: "#4d1277", // Outer color of the icon
    "& .MuiSvgIcon-root": {
      fill: "#4d1277", // Inner color of the check
    },
  },
  notCheckedIcon: {
    textAlign: "right",
    backgroundColor: "#8d8d8f",
    height: "2px",
    width: "1rem",
  },
  textOfFeat: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
}));

export default useStyles;
